import React, { Component } from 'react';
import { Button, TextArea, Modal } from 'semantic-ui-react';

class UpdatePaymentReasonModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: ''
    };
  }

  onUpdate = () => {
    const { close } = this.props;
    const { reason } = this.state;
    if (!reason) {
      alert('수정 내용을 입력해주세요');
      return;
    }
    const excludeSpace = reason.replace(/\s/gi, '');

    if (excludeSpace.length < 3) {
      alert('최소 3자 이상 입력해주세요.');
      return;
    }
    if (excludeSpace.length > 30) {
      alert('최대 30자 입력 가능합니다.');
      return;
    }
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('정말 수정하시겠습니까?')) {
      return;
    }
    this.setState({ reason: '' });
    close('ok', excludeSpace);
  };

  onCancel = () => {
    const { close } = this.props;
    const { reason } = this.state;
    // eslint-disable-next-line no-restricted-globals
    if (reason && confirm('취소 시, 수정 내용이 반영되지 않습니다. 취소하시겠습니까?')) {
      this.setState({ reason: '' });
      close(null, reason);
    } else if (!reason) {
      close(null, reason);
    }
  };

  onChange = ({ target }) => {
    const { value } = target;
    this.setState({ reason: value });
  };

  render() {
    const { open, close } = this.props;
    const { reason } = this.state;
    return (
      // dimmer={dimmer}
      <Modal className="modal-small sikdae-list-detail" open={open} onClose={close}>
        <Modal.Header>
          <span>결제사유 수정</span>
        </Modal.Header>
        <Modal.Content>
          <TextArea value={reason} className="update-reason" minLength={3} onChange={this.onChange} />
          <ul className="update-reason-notice">
            <li>최소 3자, 최대 30자 입력 가능합니다.</li>
            <li>결제내역 2개 이상 선택 수정 시. 입력하신 내용으로 일괄 수정됩니다.</li>
          </ul>
        </Modal.Content>
        <Modal.Actions>
          <Button inverted color="grey" content="취소" onClick={this.onCancel} />
          <Button positive content="수정" onClick={this.onUpdate} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default UpdatePaymentReasonModal;
